
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapMutations, mapState } from 'vuex';
    import Patient from '@/types/Patient';
    import { CardInfo } from '@/types/soap/elga/Card';

    @Component({
        computed: {
            ...mapState('globals', ['formatDate']),
            ...mapState('patient', ['loaders', 'cardInfo', 'cardInfoPatienten']),
        },
        methods: {
            ...mapActions('patient', ['loadPatient']),
            ...mapMutations('patient', ['patientNew']),
        },
    })
    export default class PatientCardDialog extends Vue {
        @Prop() visible!: boolean;
        @Prop() value!: Patient;

        public patientData = new Patient();
        public curIndex = 0;

        public cardInfo!: CardInfo;
        public cardInfoPatienten!: Patient[];
        public loadPatient!: (payload: { patnr: number }) => Promise<void>;
        public patientNew!: (visible: boolean) => void;

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                this.curIndex = 0;
            }
        }

        public get patient(): Patient {
            return this.cardInfoPatienten[this.curIndex] ?? new Patient();
        }

        public onClickLoad(): void {
            this.loadPatient({ patnr: this.patient.patnr as number });
            this.patientNew(false);
            this.$emit('close');
        }

        public onClickCancel(): void {
            this.patientNew(true);
            this.$emit('close');
        }
    }
